import { Maybe } from '../../../common/types';
import { CapacityDataType } from '../../types';
import { isEqual } from 'lodash';

type FormData = {
  moves: number;
  terminalCode: string;
  weeks: string[];
  moveCountStretchPercentage: number;
  moveCountCriticalPercentage: number;
  capacityDataType: CapacityDataType;
  yardCapacity: number;
  reeferPlugs: number;
  imoUnits: number;
  imoUnitsDescription: Maybe<string>;
  oogUnits: number;
  ladenCapacity: number;
  emptyCapacity: number;
  maxCapacity: number;
  selectedWeeks: string[];
  overwrite: boolean;
  entries: { capacityDataType: CapacityDataType }[];
};

export type WeeklyValueDtoSOC = {
  moves: number;
  terminalCode: string;
  weeks: string[];
  moveCountStretchPercentage: number;
  moveCountCriticalPercentage: number;
  capacityDataType: CapacityDataType;
  entityType: 'SOC';
  overwrite: boolean;
  entries: { capacityDataType: CapacityDataType }[];
};

export type WeeklyValueDtoYard = {
  yardCapacity: number;
  reeferPlugs: number;
  imoUnits: number;
  imoUnitsDescription: Maybe<string>;
  oogUnits: number;
  ladenCapacity: number;
  emptyCapacity: number;
  maxCapacity: number;
  terminalCode: string;
  weeks: string[];
  capacityDataType: CapacityDataType;
  entityType: 'YARD';
  overwrite: boolean;
  entries: { capacityDataType: CapacityDataType }[];
};

export type WeeklyValueDto = WeeklyValueDtoSOC | WeeklyValueDtoYard;

export const createWeeklyValueDto = (formData: FormData, type: 'soc' | 'yard'): WeeklyValueDto => {
  if (type === 'soc') {
    return {
      moves: formData.moves,
      moveCountStretchPercentage: formData.moveCountStretchPercentage,
      moveCountCriticalPercentage: formData.moveCountCriticalPercentage,
      weeks: formData.selectedWeeks,
      capacityDataType: formData.capacityDataType,
      terminalCode: formData.terminalCode,
      entityType: 'SOC',
      override: true,
      entries: [
        ...formData.entries.map((x) => ({ ...x, override: true })),
        {
          capacityDataType: CapacityDataType.Total,
          // @ts-ignore
          type: 'SOC',
          moves: formData.moves,
          moveCountStretchPercentage: formData.moveCountStretchPercentage,
          moveCountCriticalPercentage: formData.moveCountCriticalPercentage,
          override: true,
        },
      ],
    };
  }
  return {
    yardCapacity: formData.yardCapacity,
    reeferPlugs: formData.reeferPlugs,
    imoUnits: formData.imoUnits,
    imoUnitsDescription: formData.imoUnitsDescription,
    oogUnits: formData.oogUnits,
    ladenCapacity: formData.ladenCapacity,
    emptyCapacity: formData.emptyCapacity,
    maxCapacity: formData.maxCapacity,
    terminalCode: formData.terminalCode,
    weeks: formData.selectedWeeks,
    capacityDataType: formData.capacityDataType,
    entityType: 'YARD',
    overwrite: true,
    entries: [
      ...formData.entries.map((x) => ({ ...x, override: true })),
      {
        capacityDataType: CapacityDataType.Total,
        // @ts-ignore
        type: 'YARD',
        yardCapacity: formData.yardCapacity,
        reeferPlugs: formData.reeferPlugs,
        imoUnits: formData.imoUnits,
        oogUnits: formData.oogUnits,
        imoUnitsDescription: formData.imoUnitsDescription,
        ladenCapacity: formData.ladenCapacity,
        emptyCapacity: formData.emptyCapacity,
        maxCapacity: formData.maxCapacity,
        override: true,
      },
    ],
  };
};

export const setUpdatedEntries = (
  entries: (WeeklyValueDtoSOC | WeeklyValueDtoYard)[],
  original: (WeeklyValueDtoSOC | WeeklyValueDtoYard)[],
) => {
  return entries.map((e) => ({
    ...e,
    override: isEqual(
      e,
      original.find((o) => o.capacityDataType === e.capacityDataType),
    )
      ? e.overwrite
      : true,
  }));
};
